export default "__VITE_ASSET__BFWkXW51__"